import React from 'react';

class About extends React.Component {
  render() {
    return (
      <main className="mainContainer centeredVertically">
        <h1>BIO</h1>

        <p style={{ paddingBottom: "1rem" }}>
          <b>Lawrence Luo</b> is an arranger, singer, and keyboard player based in San Francisco with nearly two decades of experience creating and performing music.
          He has garnered awards for his contemporary compositions and arrangements, and his work for chamber ensembles, jazz-influenced bands, and a cappella groups are performed regularly in-concert.
        </p>

        <div id="performed-with">
          <p style={{ paddingBottom: "0.5rem" }}>Lawrence has performed with:</p>

          <ul>
            <li><a target="_blank" rel="noopener noreferrer" aria-label="RL Piano & Vocal Duo YouTube (opens in new tab)" href="https://www.youtube.com/watch?v=Jc86LBy_gws&list=PLZ8xVCciQ1ohq810z6AmckrDMgbjwDR2i&index=1&ab_channel=Lawrence%2F%2FTonic">RL Piano & Vocal Duo</a></li>
            <li><a target="_blank" rel="noopener noreferrer" aria-label="Moving Van YouTube (opens in new tab)" href="https://www.youtube.com/@MovingVanMusic">Moving Van</a></li>
            <li><a target="_blank" rel="noopener noreferrer" aria-label="The Other Reindeer Carolers Instagram (opens in new tab)" href="https://www.instagram.com/theotherreindeercarolers/">The Other Reindeer Carolers</a></li>
            <li><a target="_blank" rel="noopener noreferrer" aria-label="Alex Togashii Spotify (opens in new tab)" href="https://open.spotify.com/artist/0HVbw8ntLBVDL9fpJYMljZ?si=FtekFl36RtuUTf78rNBbBA">Alex Togashii</a></li>
            <li><a target="_blank" rel="noopener noreferrer" aria-label="Quarter After Band Instagram (opens in new tab)" href="https://www.instagram.com/QuarterAfterBand/">Quarter After Band</a></li>
            <li><a target="_blank" rel="noopener noreferrer" aria-label="The A Cappella Collective YouTube (opens in new tab)" href="https://www.youtube.com/channel/UCUmsLPXkFTBv5TpdUuedSdw">The A Cappella Collective</a></li>
            <li><a target="_blank" rel="noopener noreferrer" aria-label="Boston University&apos;s In Achord YouTube (opens in new tab)" href="https://www.youtube.com/user/buinachord2">Boston University&apos;s In Achord</a></li>
          </ul>
        </div>
      </main>
    )
  }
}

export default About;